import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import KeyFeatures from "../components/KeyFeatures"
import CoreComponents from "../components/CoreComponents"
import Benefits from "../components/Benefits"
import WhyChooseSolution from "../components/WhyChooseSolution"
import GetStartedCard from "../components/GetStartedCard"
import GetInTouch from "../components/GetInTouch"
import heroBg from "../assets/hero-bg.png"
import petrolImg from "../assets/petrol.png"
import trackSmartImg from "../assets/tracksmart.jpg"
import realTimeAlertsImg from "../assets/Real-Time-Alerts.png"
import dmsImg from "../assets/DMS.png"
import adasImg from "../assets/ADAS.png"
import compliance from "../assets/compliance.png"
import efficiency from "../assets/efficiency.webp"
import safety from "../assets/safety.jpeg"
import reduce from "../assets/reduce.webp"

const keyFeatures = [
  {
    title: "High-Definition Video Recording",
    desc: "FleetVision utilizes high-definition cameras to capture clear and detailed footage of both the road ahead and the vehicle's interior. This clarity is crucial for incident analysis, driver behavior assessment, and training purposes.",
  },
  {
    title: "Real-Time GPS Tracking",
    desc: "The system provides real-time GPS tracking, allowing fleet managers to monitor vehicle locations, optimize routes, and respond promptly to any deviations or emergencies.",
  },
  {
    title: "Event-Based Video Alerts",
    desc: "FleetVision is equipped to detect and alert on specific driving events such as harsh braking, rapid acceleration, or sudden lane changes. These alerts enable proactive interventions to address risky driving behaviors.",
  },
  {
    title: "Integration with Fleet Management Systems",
    desc: "FleetVision can seamlessly integrate with existing fleet management platforms, allowing for unified data analysis and streamlined operations across various systems.",
  },
]

const coreComponents = [
  {
    label: "Driver Monitoring System (DMS)",
    desc: "Our DMS keeps a vigilant eye on in-cabin activities, detecting behaviors that could compromise safety. By identifying these behaviors in real time, the system alerts managers, enabling prompt corrective actions and enhancing overall road safety.",
    image: dmsImg,
    imageAlt: "Driver monitoring system inside vehicle",
    imagePosition: "left",
    items: [
      "Drowsiness detection to prevent fatigue-related accidents",
      "Distraction monitoring to ensure driver attention",
      "Smoking detection for policy compliance",
      "Mobile phone usage alerts to prevent distracted driving",
    ],
  },
  {
    label: "Advanced Driver Assistance System (ADAS)",
    desc: "ADAS focuses on external factors, monitoring the vehicle's surroundings to prevent accidents and promote proactive driving habits. This system provides critical warnings and insights to help drivers navigate safely.",
    image: adasImg,
    imageAlt: "Advanced driver assistance system road monitoring",
    imagePosition: "right",
    items: [
      "Lane departure warnings to keep vehicles safely in their lane",
      "Forward collision alerts to prevent rear-end accidents",
      "Pedestrian crossing detection for enhanced urban safety",
      "Traffic sign recognition for improved regulatory compliance",
    ],
  },
]

const scrollToWhyChoose = () => {
  document
    .getElementById("why-choose-solution")
    ?.scrollIntoView({ behavior: "smooth" });
};

const benefits = [
  {
    number: "01",
    title: "Enhanced Safety",
    image:safety,
    desc: "Proactively monitor and manage driver behavior to prevent accidents and ensure the safety of your drivers, vehicles, and cargo.",
  },
  {
    number: "02",
    title: "Operational Efficiency",
    image: efficiency,
    desc: "Gain insights into fleet operations, leading to informed decision-making and optimized performance across your entire fleet.",
  },
  {
    number: "03",
    title: "Cost Reduction",
    image: reduce,
    desc: "Lower insurance premiums and reduce expenses related to accidents and vehicle downtime, improving your bottom line.",
  },
  {
    number: "04",
    title: "Compliance Assurance",
    image: compliance,
    desc: "Maintain records and evidence to meet regulatory requirements and standards, avoiding penalties and ensuring legal operation.",
  },
]

const whyChooseItems = [
  {
    number: "01",
    title: "Real-Time Alerts",
    desc: "Get instant notifications for harsh braking, sudden acceleration, lane departure, distracted driving, drowsiness, and other risky driving events.",
    image: realTimeAlertsImg,
    imageAlt: "Real-time video telematics alerts dashboard",
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "02",
    title: "Data-Driven Insights",
    desc: "Access detailed reports and analytics to review driver behavior, vehicle usage, route performance, safety events, and fleet efficiency from one platform.",
    image: dmsImg,
    imageAlt: "Driver monitoring analytics and safety insights",
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "03",
    title: "Scalable Integration",
    desc: "Seamlessly integrate video telematics with your existing fleet management systems, making it suitable for small fleets, transport networks, and enterprise operations.",
    image: adasImg,
    imageAlt: "Advanced driver assistance system integration",
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "04",
    title: "User-Friendly Interface",
    desc: "Monitor live video, alerts, trips, driver events, and fleet reports through a simple dashboard designed for quick adoption and daily operational use.",
    image: trackSmartImg,
    imageAlt: "User-friendly fleet management interface",
    linkText: "Learn more",
    href: "/services",
  },
]

export default function Section10() {
  const containerClass =
    "mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12 xl:px-20"

  return (
    <>
      <section className="relative mx-auto w-full max-w-[calc(100%-24px)] overflow-hidden rounded-b-[42px] bg-black sm:max-w-[calc(100%-32px)] lg:max-w-[calc(100%-48px)]">
        <Navbar />

        <div
          className="relative min-h-[560px] bg-cover bg-center sm:min-h-[620px] lg:min-h-[700px]"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="absolute inset-0 bg-black/68" />

          <div className="relative z-10 flex min-h-[560px] items-center justify-center px-5 pt-24 text-center sm:min-h-[620px] lg:min-h-[700px]">
            <div className="mx-auto max-w-[920px]">
              <h1 className="text-[34px] font-bold leading-tight text-white sm:text-5xl lg:text-[60px]">
                Advanced Video Telematics <br className="hidden sm:block" />
                Software
              </h1>

              <div className="mx-auto mt-3 h-[3px] w-[240px] rounded-full bg-[#ed860f] sm:w-[420px] lg:w-[520px]" />

              <p className="mx-auto mt-7 max-w-[760px] text-sm leading-relaxed text-white/75 sm:text-base">
                Experience 360° visual fleet supervision — ensure the safety of your vehicles, drivers, and consignments with our state-of-the-art video telematics software.
              </p>

              <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
             <button
  onClick={scrollToWhyChoose}
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md bg-[#ed860f] px-8 py-4 text-sm font-medium text-white transition hover:bg-[#d9780d]"
                >
                  Explore Features
                </button>

                <a
                  href="/contact"
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md border border-white px-8 py-4 text-sm font-medium text-white transition hover:bg-white hover:text-black"
                >
                  Request demo
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

<div id="why-choose-solution">
      <KeyFeatures title="Key Features" features={keyFeatures} />
      </div>

      <CoreComponents sections={coreComponents} />

      <Benefits
        title="Benefits of Our Solution"
        subtitle="Our Video Telematics Solution delivers significant advantages for fleet management and safety."
        items={benefits}
        image={trackSmartImg}
        imageAlt="Video telematics fleet management platform"
      />

      <WhyChooseSolution
  title="Why Choose Our Solution?"
  subtitle="Our Video Telematics Software stands out with these distinctive advantages."
  items={whyChooseItems}
/>

      <section className="bg-white py-10 sm:py-12 lg:py-16">
        <div className={containerClass}>
          <GetStartedCard
            title="Get Started in Minutes"
            desc="Experience the power of automation with FleetRobo® AIS-140 ICAT Certified Devices"
            primaryText="Explore Solutions"
            secondaryText="Contact us"
            primaryHref="/services"
            secondaryHref="/contact"
          />
        </div>
      </section>

      <Footer />
    </>
  )
}
